<template>
  <div id="container">
      <Spinner :show="loading"></Spinner>
      <Header></Header>
      <CashModal :active="paymentMethod == 'cash'"></CashModal>
      <MobileMoneyModal :active="paymentMethod == 'mobileMoney'"></MobileMoneyModal>
      <WalletTabs></WalletTabs>
      <section ref="content" id="content" class="section subnav no-vpadding">
          <Notification v-if="notification.show" :text="notification.text" :className="notification.className"></Notification>
          <!-- <h4 class="is-size-4 has-text-centered">{{ $t("BuyingCredit") }}</h4> -->
          <div class="columns is-mobile is-centered">
            <div class="column is-full">
                <!-- <p class="has-text-centered">{{ $t("BuyingCreditBody") }}</p> -->
                <div class="control has-icons-left">
                    <div class="select is-fullwidth">
                        <select v-model="paymentMethod">
                            <option disabled value="disabled">{{ $t("PaymentMethod") }}</option>
                            <option value="cash">{{ $t("Cash") }}</option>
                            <option value="mobileMoney">{{ $t("MobileMoney") }}</option>
                        </select>
                    </div>
                    <div class="icon is-small is-left">
                        <i class="fa fa-money"></i>
                    </div>
                </div>
            </div>
          </div>
      </section>
      <NavigationTabs></NavigationTabs>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import CashModal from "@/components/CashModal.vue";
import MobileMoneyModal from "@/components/MobileMoneyModal.vue";
import WalletTabs from "@/components/WalletTabs.vue";
import Notification from "@/components/Notification.vue";
import NavigationTabs from "@/components/NavigationTabs.vue";
import Spinner from "@/components/Spinner.vue";

export default {
  name: "Wallet",
  components: {
    Header,
    CashModal,
    MobileMoneyModal,
    WalletTabs,
    Notification,
    NavigationTabs,
    Spinner
  },
  data () {
      return {
          paymentMethod: "disabled"
      }
  }
};
</script>
